import React, { createContext, useContext, useState } from "react";
import { useApi } from "./ApiContext";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
	const [currentProject, setCurrentProject] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const { api } = useApi();

	const loadProject = async (projectId) => {
		setIsLoading(true);
		setError(null);
		try {
			const response = await api(`/canvas?projectId=${projectId}`);
			console.log("Project loaded:", response);
			setCurrentProject(response);
		} catch (err) {
			console.error("Error loading project:", err);
			setError(err.message);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<ProjectContext.Provider
			value={{
				currentProject,
				setCurrentProject,
				isLoading,
				error,
				loadProject,
			}}>
			{children}
		</ProjectContext.Provider>
	);
};

export const useProject = () => {
	const context = useContext(ProjectContext);
	if (!context) {
		throw new Error("useProject must be used within a ProjectProvider");
	}
	return context;
};

export default ProjectContext;
